import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MessageSquareTextIcon } from 'lucide-react';
import { FIRM } from '../../lib/constants';
export function MobileStickyCTA() {
  return <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 border-t border-navy/10 bg-cream/95 backdrop-blur lg:hidden" data-id="element-339">
      <a href={FIRM.phoneHref} className="flex items-center justify-center gap-2 border-r border-navy/10 py-3.5 text-sm font-semibold text-navy" data-id="element-340">
        <PhoneIcon className="h-4 w-4 text-brass-dark" data-id="element-341" />
        Call
      </a>
      <Link to="/enquiry" className="flex items-center justify-center gap-2 bg-brass py-3.5 text-sm font-semibold text-white" data-id="element-342">
        <MessageSquareTextIcon className="h-4 w-4" data-id="element-343" />
        Enquire
      </Link>
    </div>;
}